/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LinkedIdentity = {
    type: LinkedIdentity.type;
    value?: string | null;
    telegram_user_id?: number | null;
    username?: string | null;
    linked_at: string;
};
export namespace LinkedIdentity {
    export enum type {
        EMAIL = 'email',
        TELEGRAM = 'telegram',
    }
}

